import type { Article } from "~/api/prismic/types"
import { PageRoutes } from "~/enums/PageRoutes"
import { publicConfig } from "~/utils/config"

export const getArticleLink = ({ uid }: Pick<Article, "uid">): string => {
  return PageRoutes.ARTICLE.replace("[uid]", uid)
}

export const getArticleFullURL = (uid: string): string => {
  const url = new URL(publicConfig.siteURL)

  url.pathname = PageRoutes.ARTICLE.replace("[uid]", uid)

  return url.toString()
}
